import { render, staticRenderFns } from "./BlockingLink.vue?vue&type=template&id=f2462560&lang=pug"
import script from "./BlockingLink.vue?vue&type=script&lang=ts"
export * from "./BlockingLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports